import {
   PipelineModel,
   usePipelineStore
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'
import { useGetPipelineCustomizations } from '@flowwai-frontend/bps-officer-web/iam'

import { getCallLogsPipelines } from '../utils/CallLogUtils'

interface ReturnType {
   callLogsPipelines: Array<PipelineModel>
   isCallsEnabled: boolean
}

const useGetPipelineCallsDetails = (): ReturnType => {
   const pipelineStore = usePipelineStore()

   const pipelineCustomizations = useGetPipelineCustomizations()

   const callLogsPipelines = getCallLogsPipelines(
      pipelineStore.pipelines,
      pipelineCustomizations.getPipelineCustomizations
   )

   const isCallsEnabled = !!callLogsPipelines.length

   return {
      callLogsPipelines,
      isCallsEnabled
   }
}

export default useGetPipelineCallsDetails
